import { State } from 'xstate';
import { billingFilters } from './billingFilters';
import { areSomeFiltersActive } from './utils';

export type BillingFiltersMachine = typeof billingFilters;
export type BillingFiltersState = State<BillingFiltersMachine['context']>;

const isFilteringApplied = (machineState: BillingFiltersState) => {
  const filters = machineState.context.activeFilters;
  return filters && areSomeFiltersActive(filters);
};

export const getFiltersSections = (machineState: BillingFiltersState) =>
  machineState.context.sections;

export const getFiltersVisibility = (machineState: BillingFiltersState) =>
  machineState.matches('open');

export const getInlineFiltersValues = (machineState: BillingFiltersState) =>
  machineState.context.inlineFilters;

export const billingFiltersSelectors = {
  isFilteringApplied,
  getFiltersSections,
  getFiltersVisibility,
  getInlineFiltersValues,
};
